export class AuthenticationConfirmEmailModel {
    email: string;
    password: string;
    code:string;
    userId:string;

    constructor(email: string,
        password: string, userId:string,code:string) {
            this.email = email;
            this.password= password;
            this.userId= userId;
            this.code= code;

    }
}
